import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'

import { GlgTextInput } from 'Shared/components'

import useSessionStatusData from '../../hooks/useSessionStatusData'

import { selectTextSearch, setTextSearch } from '../../reducers/jobs_filters'
import { selectCustomerDateFormat } from '../../reducers/clone_leagues_sessions'
import { getDateOnlyUnixFormat } from 'Shared/date_time_format'

const SessionStatusSearch = () => {
  const { currentSession } = useSessionStatusData()
  const dispatch = useDispatch()
  const textSearch = useSelector(selectTextSearch)
  const customerDateFormat = useSelector(selectCustomerDateFormat)
  const formatDate = (isoDateString) => isoDateString ? moment(isoDateString).format(getDateOnlyUnixFormat(customerDateFormat)) : ''

  const handleTextSearchChange = (value) => {
    dispatch(setTextSearch(value))
  }

  return ( <div className={'search-container'}>
    <div className={'search-info-container'}>
      <span className={'search-info-line'}>
        <span className={'search-info-text-bold'}>
          {window.I18n.t('clone_leagues_sessions.status_modal.created_by')}:
        </span>
        <span className={'search-info-text'}>{currentSession?.created_by}</span>
      </span>
      <span className={'search-info-line'}>
        <span className={'search-info-text-bold'}>
          {window.I18n.t('clone_leagues_sessions.status_modal.date')}:
        </span>
        <span className={'search-info-text'}>{formatDate(currentSession?.created_at)}</span>
      </span>

    </div>

    <GlgTextInput
      onChange={handleTextSearchChange}
      value={textSearch}
      withAddon
    />
  </div>)
}

export default SessionStatusSearch
